import axios from "axios";
import { API } from "../api/api";
import type { CheckoutResponse, CouponValidation, Order } from "../types";

export const createOrder = async (order: Order): Promise<CheckoutResponse> => {
  const { data } = await API.post<CheckoutResponse>("/orders/checkout", order);
  return data;
};

export const validateCoupon = async (code: string, whatsapp: string): Promise<CouponValidation> => {
  const { data } = await API.post<CouponValidation>("/orders/coupon/validate", {
    code,
    customer_whatsapp: whatsapp,
  });
  return data;
};

/** Mensagem de erro de regra de negócio enviada pelo backend (ex.: cupom recusado). */
export const apiErrorMessage = (error: unknown, fallback: string) =>
  (axios.isAxiosError<{ error?: string }>(error) && error.response?.data?.error) || fallback;
